import BookmarkIcon from './app-icons/bookmark.svg';
import DislikeIcon from './app-icons/Smock_ThumbDownOutline_18_N.svg';
import DetailsIcon from './app-icons/svgexport-15.svg';

import PlusIcon from './app-icons/icon plus.svg';

import TagIcon from './app-icons/icons tag.svg';
import ChevronRightIcon from './app-icons/icons - chevron right.svg';

import HomeIcon from './app-icons/home.svg';
import PersonalizedIcon from './app-icons/svgexport-15-1.svg'

import BookmarkSolidIcon from './app-icons/bookmark_solid.svg';
import TopicsIcon from './app-icons/icons tag-1.svg';
import LatestIcon from './app-icons/clock.svg';
import HandpickedIcon from './app-icons/icon handpicked.svg';
import TwitterIcon from './app-icons/icon twitter.svg';

export {
  BookmarkIcon,
  DislikeIcon,
  DetailsIcon,
  TagIcon,
  ChevronRightIcon
};

export const FILTER_ICON =  {
  BookmarkSolidIcon,
  HomeIcon,
  LatestIcon,
  TopicsIcon,
  TwitterIcon,
  PersonalizedIcon,
  HandpickedIcon
};

export { PlusIcon };
